<template>
    <section id="delivery-page">

        <ReadyToBeDelivered
            v-if="interfaceIsDetailed"
            class="grey-container"
        />

        <AlreadyInProgressDeliveries
            v-if="interfaceIsDetailed"
            class="grey-container"
        />

        <InterfaceSimplifiedRedirector
            v-if="interfaceIsSimplified"
        />

    </section>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

// Components
import ReadyToBeDelivered from './delivery/ReadyToBeDelivered';
import AlreadyInProgressDeliveries from './delivery/AlreadyInProgressDeliveries';
import InterfaceSimplifiedRedirector from './delivery/InterfaceSimplifiedRedirector';

export default {
    name: 'MailDelivery',
    components: {
        ReadyToBeDelivered,
        AlreadyInProgressDeliveries,
        InterfaceSimplifiedRedirector,
    },
    computed: {
        ...mapGetters( {
            interfaceIsSimplified: 'Mail/Delivery/interfaceIsSimplified',
            interfaceIsDetailed: 'Mail/Delivery/interfaceIsDetailed',
        } ),
    },
};
</script>

<style lang="scss" scoped>

#delivery-page {
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    margin-bottom: 1rem;
    >:not(:last-child) {
        margin-bottom: 1rem;
    }
}

.grey-container {
    background-color: #eeeeee;
    padding: 1rem;
    border-radius: 4px;
    box-shadow: $variables-material-shadow-1;
}

@include mixins-above(tablet) {
    //
}
</style>
